import { useQuery } from '@tanstack/react-query';
import { api, unwrap } from './client';
import type { Account, Automation, Contact, Items, Page, PlanOffer } from './types';

/** The shared read models: one key, one URL and one type per query, used by every page. */
export function useAccounts() {
  return useQuery({
    queryKey: ['accounts'],
    queryFn: () => unwrap(api.get<Items<Account>>('/portal/social-accounts')),
  });
}

export function useAutomations() {
  return useQuery({
    queryKey: ['automations'],
    queryFn: () => unwrap(api.get<Items<Automation>>('/portal/automations')),
  });
}

export function usePlans() {
  return useQuery({
    queryKey: ['plans'],
    queryFn: () => unwrap(api.get<Items<PlanOffer>>('/plans')),
  });
}

/** Up to 200 contacts for client-side lookups (inbox labels); pages with filters query their own. */
export function useContactsIndex() {
  return useQuery({
    queryKey: ['contacts', 'index'],
    queryFn: () => unwrap(api.get<Page<Contact>>('/portal/contacts?limit=200')),
  });
}
